module.exports = __webpack_public_path__ + "img/top.8228468c.png";